// eslint-disable-next-line import/prefer-default-export
export enum WeeklyReportRole {
    Foreman = 'VO',
    SkilledWorker = 'FA',
    Helper = 'HE',
    Apprentice = 'AZ'
}
